// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.LongAns = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.LongAns = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var LongAns = _exports.LongAns = function LongAns(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("rect", {
      x: "1.5",
      y: "3.64941",
      width: "7.72718",
      height: "1.5",
      rx: "0.75",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      x: "1.5",
      y: "11.1201",
      width: "7.72718",
      height: "1.5",
      rx: "0.75",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      x: "10.7734",
      y: "3.64941",
      width: "4.63631",
      height: "1.5",
      rx: "0.75",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      x: "10.7734",
      y: "11.1201",
      width: "4.63631",
      height: "1.5",
      rx: "0.75",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      x: "16.9531",
      y: "3.64941",
      width: "1.54544",
      height: "1.5",
      rx: "0.75",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      x: "16.9531",
      y: "11.1201",
      width: "1.54544",
      height: "1.5",
      rx: "0.75",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      x: "1.5",
      y: "7.38477",
      width: "4.63631",
      height: "1.5",
      rx: "0.75",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      x: "1.5",
      y: "14.8584",
      width: "4.63631",
      height: "1.5",
      rx: "0.75",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      x: "7.68164",
      y: "7.38477",
      width: "10.818",
      height: "1.5",
      rx: "0.75",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      x: "7.68164",
      y: "14.8584",
      width: "10.818",
      height: "1.5",
      rx: "0.75",
      fill: "#212B36"
    }));
  };
});
